import {StyledLogo, StyledTitleWrapper, StyledBillingData, StyledDataTitle, StyledQuoteName} from './style'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'
import LogoIcon from '@assets/images/LOGO_ARYA_SUNPRO.png'
import {useTranslation} from 'react-i18next'
import {QuoteType} from '../../types'
import {StyledContacts} from '../summary-quote/style'

export const SimplifiedQuoteTitle = ({quoteData}: {quoteData: QuoteType}) => {
    const {t} = useTranslation()

    return (
        <StyledTitleWrapper>
            <Flexbox>
                <StyledLogo>
                    <img src={LogoIcon} alt={'arya-icon'} />
                </StyledLogo>
            </Flexbox>
            <StyledBillingData>
                <Flexbox direction={'column'} gap={1}>
                    <StyledDataTitle>{t('quote:summary:prepared_by')}</StyledDataTitle>
                    <StyledQuoteName>{quoteData?.fromCompany?.name}</StyledQuoteName>
                    <Flexbox gap={1}>
                        <StyledContacts>{t('commons:client_vat') + ':'}</StyledContacts>
                        <StyledContacts>{quoteData?.fromCompany?.vatNumber ?? '-'}</StyledContacts>
                    </Flexbox>
                </Flexbox>
                <Flexbox direction={'column'} gap={1}>
                    <StyledDataTitle>{t('projects:client') + ':'}</StyledDataTitle>
                    <StyledQuoteName>{quoteData?.toCompany?.name}</StyledQuoteName>
                    <Flexbox gap={1}>
                        <StyledContacts>{t('commons:client_vat') + ':'}</StyledContacts>
                        <StyledContacts>{quoteData?.toCompany?.vatNumber ?? '-'}</StyledContacts>
                    </Flexbox>
                </Flexbox>
            </StyledBillingData>
        </StyledTitleWrapper>
    )
}
